import jwtDecode from 'jwt-decode';

export const PLATFORM_ACCESS_TOKEN_KEY = 'platformAccessToken';
export const PLATFORM_REFRESH_TOKEN_KEY = 'platformRefreshToken';

function storage() {
    return typeof window !== 'undefined' ? window.localStorage : null;
}

export function getPlatformAccessToken() {
    const target = storage();
    return target ? target.getItem(PLATFORM_ACCESS_TOKEN_KEY) : null;
}

export function getPlatformRefreshToken() {
    const target = storage();
    return target ? target.getItem(PLATFORM_REFRESH_TOKEN_KEY) : null;
}

export function decodePlatformToken(token = getPlatformAccessToken()) {
    if (!token) return null;
    try {
        return jwtDecode(token);
    } catch (error) {
        return null;
    }
}

export function isPlatformAccessTokenValid(token = getPlatformAccessToken()) {
    const payload = decodePlatformToken(token);
    if (!payload || payload.tokenType !== 'platform' || payload.role !== 'platform_admin') {
        return false;
    }
    return Number(payload.exp || 0) * 1000 > Date.now() + 5000;
}

export function canRestorePlatformSession() {
    return isPlatformAccessTokenValid() || Boolean(getPlatformRefreshToken());
}

export function setPlatformSession(session) {
    const target = storage();
    if (!target || !session) return;
    if (session.accessToken) target.setItem(PLATFORM_ACCESS_TOKEN_KEY, session.accessToken);
    if (session.refreshToken) target.setItem(PLATFORM_REFRESH_TOKEN_KEY, 'cookie');
}

export function clearPlatformSession() {
    const target = storage();
    if (!target) return;
    target.removeItem(PLATFORM_ACCESS_TOKEN_KEY);
    target.removeItem(PLATFORM_REFRESH_TOKEN_KEY);
}

export function getPlatformUserFromToken() {
    const payload = decodePlatformToken();
    if (!payload) return null;
    return {
        id: payload.id || payload.sub,
        login: payload.login,
        displayName: payload.displayName,
        role: payload.role
    };
}
